import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { KeycloakAngularModule } from 'keycloak-angular';
import { TasksQueueComponent } from 'src/app/tasks-queue/tasks-queue.component';
import { AclModule } from './acl/acl.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FeatureFlagsModule } from './feature-flags/feature-flags.module';
import { SplashScreenModule } from './_metronic/partials';
import { ToastModule } from './toast/toast.module';
import { AuthModule } from './auth/auth.module';
import { ServerTimeModule } from './server-time/server-time.module';
import { I18nModule } from './i18n/i18n.module';
import { WhiteLabelModule } from './white-label/white-label.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    KeycloakAngularModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    SplashScreenModule,
    ToastModule,
    AuthModule,
    ServerTimeModule,
    I18nModule,
    AclModule,
    FeatureFlagsModule,
    WhiteLabelModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    // Instrumentation must be imported after importing StoreModule (config is optional)
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true
    }),
    TasksQueueComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
